import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import * as XLSX from 'xlsx';

import Loader from './../../../component/common/Loader';
import CONSTANT from '../../../constant';
import Header from '../../../component/common/UnitLeaveHeader';
import { getUnitLeaveReport } from '../../../actions/UnitLeaveAction';
import { onChange, } from '../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            date: new Date(),
            list: undefined,
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { leaveType, date, list, showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Leaves balance as on {`${moment().format('DD MMM YYYY')}`}</h1>
                            </div>
                        </div>
                        {this.renderPagination()}
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Employee Number</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Unit</th>
                                                <th scope="col" title="Casual leave">CL</th>
                                                <th scope="col" title="RH">RH</th>
                                                <th scope="col" title="Encashable">EL</th>
                                                <th scope="col" title="Non-Encashable">NON-EL</th>
                                                <th scope="col" title="HPL">HPL</th>

                                            </tr>
                                            {
                                                list === undefined && <tr>
                                                    <td colSpan={10} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.length === 0 && <tr>
                                                    <td colSpan={10} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.map((item: any, index: number) => {
                                                    const detailPageURL = `${CONSTANT.component.unitAddLeave.url}?code=${item.code}`;
                                                    const cl = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.cl)[0];
                                                    const rh = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.rh)[0];
                                                    const el = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.el)[0];
                                                    const nonel = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.nonel)[0];
                                                    const hpl = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.hpl)[0];;
                                                    return (
                                                        <tr className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.employeeNumber}</td>
                                                            <td>{item.name}</td>
                                                            <td>{item.unitName}</td>
                                                            <td>
                                                                {`${cl.total - cl.used}`}
                                                            </td>
                                                            <td>
                                                                {`${rh.total - rh.used}`}
                                                            </td>
                                                            <td>
                                                                {`${el.total - el.used}`}
                                                            </td>
                                                            <td>
                                                                {`${nonel.total - nonel.used}`}
                                                            </td>
                                                            <td>
                                                                {`${hpl.total - hpl.used}`}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div >
        )
    }

    renderPagination = () => {
        return (
            <div className="row mt-3">
                <div className="col-md-8"></div>
                <div className="col-md-2">
                    <Link to={CONSTANT.component.unitBulkUpdateLeave.url} className="btn btn-sm btn-block submit-button">Update Leave Balance</Link>
                </div>
                <div className="col-md-2">
                    <button type="button" onClick={this.downloadExcel} className="btn btn-sm btn-block submit-button">Download Report</button>
                </div>
            </div>
        )
    }

    loadList = () => {
        this.setState({ showLoader: true });
        getUnitLeaveReport().then((res: any) => {
            this.setState({ list: res.result, showLoader: false });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        onChange(this, name, value);
    }

    downloadExcel = (e: any) => {
        const { list, date } = this.state;
        if (list.length === 0) {
            alert('No records found.');
            return;
        }
        let filename = `leave-balance-${date.getFullYear()}.xlsx`;
        let dataToExport: any = [];
        var ws_name = "Sheet1";
        list.map(function (item: any) {
            delete item.code;
            const cl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cl)[0];
            const el = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.el)[0];
            const nonel = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.nonel)[0];
            const hpl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.hpl)[0];
            // const mat = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.mat)[0];
            const cml = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cml)[0];
            const rh = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.rh)[0];
            const dated = date.toDateString();

            dataToExport.push({
                EmployeeNumber: item.employeeNumber,
                Name: item.name,
                Dated: dated,

                CL: cl.total - cl.used,
                RH: rh.total - rh.used,
                EL: el.total - el.used,
                "NON-EL": nonel.total - nonel.used,
                HPL: hpl.total - hpl.used
            });
        });
        var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(dataToExport);
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, filename);
    }
}

export default ComponentName;